import React from 'react'

function Timeline() {
  return (
    <section class="timeline-section-four pt-0" id="rsvp">
        <div class="auto-container">
            <div class="sec-title text-center">
            <div class="icon-divider-4"></div>
            <h2>Programme Timeline</h2>
            </div>
            <div class="outer-box">
            <div class="timeline-block-four wow fadeInLeft">
                <div class="inner-box">
                <div class="icon-box">
                    <i class="icon flaticon-wedding-arch-1"></i>
                    <div class="icon-flower-18"></div>
                </div>
                <div class="content-box">
                    <div class="time">10:00 am - 11:00 am</div>
                    <h4 class="title"><a href="#">Reception</a></h4>
                    <div class="text">
                    We know what papers you need, we <br />
                    know all the best vendors for your <br />
                    arrangement.
                    </div>
                </div>
                </div>
            </div>

            <div class="timeline-block-four style-two wow fadeInRight" data-wow-delay="300ms">
                <div class="inner-box">
                <div class="icon-box">
                    <i class="icon flaticon-wedding-ring"></i>
                    <div class="icon-flower-18"></div>
                </div>
                <div class="content-box">
                    <div class="time">10:00 am - 11:00 am</div>
                    <h4 class="title"><a href="#">Ceremony</a></h4>
                    <div class="text">
                    We know what papers you need, we <br />
                    know all the best vendors for your <br />
                    arrangement.
                    </div>
                </div>
                </div>
            </div>

            <div class="timeline-block-four wow fadeInLeft" data-wow-delay="600ms">
                <div class="inner-box">
                <div class="icon-box">
                    <i class="icon flaticon-love-birds"></i>
                    <div class="icon-flower-18"></div>
                </div>
                <div class="content-box">
                    <div class="time">10:00 am - 11:00 am</div>
                    <h4 class="title"><a href="#">Photoshoot</a></h4>
                    <div class="text">
                    We know what papers you need, we <br />
                    know all the best vendors for your <br />
                    arrangement.
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
    </section>
  )
}

export default Timeline